module.exports = require('./helpers/bundle-url').getBundleURL('h9q3T') + "Rose Wallet Blue.189366a3.svg";